'use client';

import type { ElementType } from 'react';
import { usePathname } from 'next/navigation';
import type { ContentfulClickProps } from './types';
import { trackContentfulClick } from '../../gtm';

export function ContentfulClick<T extends ElementType = 'div'>({
    component,
    eventData,
    onClick,
    ...props
}: ContentfulClickProps<T>) {
    const Component = component ?? 'div';
    const pathname = usePathname();

    return (
        <Component
            {...props}
            onClick={e => {
                onClick?.(e);
                trackContentfulClick({
                    ...eventData,
                    promoOrigin: pathname,
                });
            }}
        />
    );
}
